import logstream from './src/core.monitoring.logstream';

namespace Monitoring {
    export function init() : void {}
    export class Logstream extends logstream { }
}

export default Monitoring;